import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import ReAssignOption from "./ReAssignOption";
import { showErrorToast, showSuccessToast } from "../Constant/Notification";
import teamService from "../Services/TeamService";
import Loader from "../Constant/Loader";
import Modal from "react-modal";
import { getIcons } from "../Constant/Constant";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import LeadDbService from "../Services/LeadDbService";
import AssignOption from "./AssignOption";
import ReAssignLead from "../Services/ReAssignLead";
import { teamIds, userRole } from "../../utils/storage";

const ReAssignIndividualLead = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const defaultTeamId =
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : null;

  const leadTeamName = location.state?.leadTeam || "";
  const leadUserName = location.state?.leadUser || "";
  const leadSourceId = location.state?.leadSourceId || "";
  const assignStatus = location.state?.assignStatus || "";
  const teamId = location.state?.teamId || defaultTeamId;
  const memberId = location.state?.memberId || "";
  const leadCount = location.state?.leadCount || 0;
  const teamStatus = location.state?.teamStatus || false;

  // Lead DB : Reasign to leadList Array

  const leadListArray = location.state?.leadListArray || [];

  console.log(leadListArray?.length);

  console.log("Lead Team ", location.state);
  const leadId = location.state?.leadId || "";
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState(teamId || null);
  const [selectedUserId, setSelectedUserId] = useState(memberId || null);
  const [leadCounts, setLeadCounts] = useState(0);
  const [remainingLeads, setRemainingLeads] = useState(leadCount || 0);
  const [isActive, setIsActive] = useState(true);

  const [prevAssignedUserId, setPrevAssignedUserId] = useState();
  const [prevAssignedTeamId, setPrevAssignedTeamId] = useState();

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userUid = userData?.user?.uid;

  const icon = getIcons();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await teamService.fetchTeams();
        setTeams(response.data);

        const foundTeam = response.data.find(
          (team) => team.name === leadTeamName
        );
        if (foundTeam) {
          setSelectedTeamId(foundTeam.teamId);
          setPrevAssignedTeamId(foundTeam.teamId);

          const users = [
            ...foundTeam.BOD,
            foundTeam.MD,
            ...foundTeam.members,
          ].filter((user) => user.name);

          const foundUser = users.find((user) => user.name === leadUserName);
          if (foundUser) {
            setSelectedUserId(foundUser.id);
            setPrevAssignedUserId(foundUser.id);
          }
        }
      } catch (error) {
        showErrorToast(error.response?.message || "Error fetching teams");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [leadTeamName, leadUserName]);

  const selectedTeam = teams.find((team) => team.teamId === selectedTeamId);
  const selectedTeamUsers = selectedTeam
    ? [...selectedTeam.BOD, selectedTeam.MD, ...selectedTeam.members].filter(
        (user) => user.name
      )
    : [];

  const icons = getIcons();

  const handleOpenModal = () => {
    const selectedUser = selectedTeamUsers.find(
      (user) => user.id === selectedUserId
    );

    if (!selectedUserId) {
      showErrorToast("Please select a user to reassign.");
      return;
    }

    if (selectedUser?.name === leadUserName) {
      showErrorToast("You cannot reassign to the same user.");
      return;
    }

    setIsOpenModal(true);
  };

  const handelAssign = async () => {
    if (leadCounts === undefined) {
      showErrorToast("Team not found.");
      return;
    }

    setLoading(true);
    
    try {
      if (leadCount === 1) {
        const body = {
          leadId: leadId,
          teamId: selectedTeamId,
          assignedBy: userUid,
          assignedToUser: selectedUserId,
          team: teamId ? true : false,
        };

        const response = await LeadDbService.assignSingleLead(body);
        

        if (response.status === 201) {
          showSuccessToast("Lead assigned successfully!");
          setIsOpenModal(false);
          setTimeout(() => {
            navigate(-2, { state: { message: "Lead Assigned successfully!" } });
          }, 2000);
        }
      } else {
        let body = {};
        if(userRole === "BOD"){
          body = {
            assignedTeamId: selectedTeamId,
            assigneeCount: leadCounts,
          };

        }else{
    
          if (teamStatus === false) {
            body = {
              teamType: teamStatus,
              assignedTeamId: selectedTeamId,
              leadSourceId: leadSourceId,
              assigneeCount: leadCounts,
            };

          } else {
            body = {
              teamType: teamStatus,
              filterTeamId: teamId,
              assignedTeamId: selectedTeamId,
              leadSourceId: leadSourceId,
              assigneeCount: leadCounts,
            };
          }
        }

        let response ;

        if (userRole === "BOD") {
          response = await LeadDbService.postBODBulkAssign(body);
        } else {
          response = await LeadDbService.postAssignLeads(body);
        }
      
        console.log(response);

        if (response.status === 201) {
          showSuccessToast("Lead assigned successfully!");
          setIsOpenModal(false);
          setTimeout(() => {
            navigate(-2, { state: { message: "Lead Assigned successfully!" } });
          }, 2000);
        } else {
          showErrorToast("Failed to reassign lead.");
        }
      }
      setLeadCounts("");
    } catch (error) {
      console.error(error);
      showErrorToast("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleReassignLead = async () => {
    if (!selectedTeamId || !selectedUserId || !userUid) {
      showErrorToast("Invalid reassignment data. Please try again.");
      return;
    }

    const isSameTeam = selectedTeamId === prevAssignedTeamId;
    const isSameUser = selectedUserId === prevAssignedUserId;

    if (isSameTeam && isSameUser) {
      showErrorToast("You cannot reassign to the same team and user.");
      return;
    }

    if (leadListArray.length === 0) {
      const requestBody = {
        leadId: leadId,
        reAssignedBy: userUid,
        existingAssignedUserId: prevAssignedUserId,
        newAssignedUserId: selectedUserId,
        existingAssignedTeamId: prevAssignedTeamId,
        newAssignedTeamId: selectedTeamId,
        withData: isActive,
      };

      try {
        setLoading(true);
        setIsOpenModal(false);

        const response = await ReAssignLead.resignSingleLead(requestBody);

        if (response.status === 200) {
          showSuccessToast("Lead reassigned successfully");
          setTimeout(() => {
            navigate(-1, {
              state: { message: "Lead Reassigned successfully!" },
            });
          }, 1500);
        }
      } catch (error) {
        showErrorToast(
          error.response?.data?.message || "Failed to reassign lead."
        );
      } finally {
        setLoading(false);
      }
    } else {
      const requestBody = {
        leadIds: leadListArray,
        reAssignedBy: userUid,
        newAssignedUserId: selectedUserId,
        newAssignedTeamId: selectedTeamId,
        withData: isActive,
      };


      try {
        setLoading(true);
        setIsOpenModal(false);

        const response = await ReAssignLead.resignBulkLead(requestBody);

        if (response.status === 200) {
          showSuccessToast("Lead reassigned successfully");
          setTimeout(() => {
            navigate(-1, {
              state: { message: "Lead Reassigned successfully!" },
            });
          }, 1500);
        }
      } catch (error) {
        showErrorToast(
          error.response?.data?.message || "Failed to reassign lead."
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleToggleClick = () => {
    setIsActive((prev) => !prev);
  };

  const handleAssignTeamSelect = (list, remainingLeads) => {
    console.log("Selected Team ID:", list);
    setLeadCounts(list);
    setRemainingLeads(remainingLeads);
  };

  return (
    <div className="bg-appGrayBackground">
      {loading && <Loader />}
      <AdminAppBar />
      <ToastContainer />
      <div className="h-full py-20 mt-7">
        <div className="flex  px-8 justify-between items-center">
          <div className=" flex pt-2 items-center">
            <svg
              onClick={() => navigate(-1)}
              className="cursor-pointer relative md:w-5 md:h-7 lg:w-5 lg:h-9"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>

            <div className="font-semibold md:mx-0 cursor-default text-3xl lg:mx-6 mx-14">
              <div className="flex items-center gap-5 ml-4">
                {" "}
                <div> {assignStatus ? "Assign" : "Re - Assign"}</div>
                <div>{assignStatus ? `( ${remainingLeads} )` : ""}</div>
              </div>
            </div>
          </div>
          {!assignStatus && (
            <div className="flex items-center space-x-2 mr-14">
              <span
                className={
                  isActive
                    ? "text-lg font-medium"
                    : "text-red-600 text-lg font-medium"
                }
              >
                Transfer without data
              </span>

              <label className="inline-flex items-center cursor-pointer">
                <div className="relative">
                  <input
                    type="checkbox"
                    onClick={handleToggleClick}
                    className="sr-only"
                    checked={isActive}
                  />
                  <div className="w-11 h-6 bg-gray-200 rounded-full"></div>
                  <div
                    className={`absolute left-1 top-1 w-4 h-4 rounded-full transition-transform ${
                      isActive
                        ? "translate-x-5 bg-green-500"
                        : "bg-red-500 translate-x-0"
                    }`}
                  ></div>
                </div>
              </label>

              <span
                className={
                  isActive
                    ? "text-green-600 text-lg font-medium"
                    : "text-black text-lg font-medium"
                }
              >
                Transfer with data
              </span>
            </div>
          )}
        </div>

        <div>
          <div className="flex  px-20   mt-4">
            <div className="flex py-3 px-10 bg-white items-center justify-between rounded-lg w-full  ">
              <div className="flex text-xl text-customGreen font-medium  items-center">
                Selected Leads is {remainingLeads}
              </div>

              {assignStatus ? (
                <button
                 disabled={loading}
                   onClick={handelAssign}
                   className = {` rounded-md p-2 text-white h-10 w-fit ${loading ? "bg-gray-400" : "bg-customGreen" } `}
               
                >
                  Assign
                </button>
              ) : (
                <button
                disabled={loading}
                  onClick={handleOpenModal}
                  className = {`rounded-md p-2 text-white h-10 w-fit ${loading ? "bg-gray-400" : "bg-customGreen " } `}
                
                >
                  Reassign
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col px-20 py-6 gap-6">
          <div className="flex flex-col items-center gap-8 w-full bg-white rounded-md p-4">
            <div className="flex gap-3 w-full">
              {userRole !== "BOD" ? (
                <>
                  <ReAssignOption
                    title="Teams"
                    teamList={teams}
                    selectedId={selectedTeamId}
                    onSelectTeam={(teamId) => setSelectedTeamId(teamId)}
                  />
                </>
              ) : (
                <div className="w-1/2 ">
                  <img
                    src={icon?.teamIcon}
                    className="h-[400px] w-full border rounded-md"
                  />
                </div>
              )}

              {assignStatus && leadCount > 1 ? (
                <AssignOption
                  title={"Users"}
                  teamList={selectedTeamUsers}
                  totalLead={leadCount}
                  selectedId={selectedUserId}
                  onSelectTeam={handleAssignTeamSelect}
                />
              ) : (
                <ReAssignOption
                  title="Users"
                  teamList={selectedTeamUsers}
                  selectedId={selectedUserId}
                  onSelectTeam={(userId) => setSelectedUserId(userId)}
                />
              )}
            </div>
            {/* {assignStatus ? (
              <button
                onClick={handelAssign}
                className="h-10 w-fit bg-customGreen text-white p-2 rounded-md"
              >
                Assign
              </button>
            ) : (
              <div>
               <button
                  onClick={handleOpenModal}
                  className="h-10 w-fit bg-customGreen text-white p-2 rounded-md"
                >
                  Reassign
                </button>
              </div>
            )} */}
          </div>
        </div>
      </div>

      <Modal
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
        contentLabel="Confirmation"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "40%",
            padding: "20px",
            position: "relative",
          },
          overlay: {
            zIndex: 1000,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
          },
        }}
      >
        <div className="flex flex-col items-center justify-center gap-5">
          <div className="flex items-center justify-center">
            <img src={icons.confirmationWarning} alt="" />
          </div>

          <h1 className="text-xl font-semibold">Are you sure?</h1>
          <h1>Are you sure you want to reassign the lead info?</h1>

          <div className="flex gap-6 text-white font-medium text-center">
            <button
              className="bg-gray-300 w-20 rounded-md h-10 p-2"
              onClick={() => setIsOpenModal(false)}
            >
              Cancel
            </button>
            <button
              onClick={handleReassignLead}
              className="bg-customGreen w-20 rounded-md h-10 p-2"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ReAssignIndividualLead;
